import { render, staticRenderFns } from "./2.vue?vue&type=template&id=3b8a682e&scoped=true&"
import script from "./2.vue?vue&type=script&lang=js&"
export * from "./2.vue?vue&type=script&lang=js&"
import style0 from "./2.vue?vue&type=style&index=0&id=3b8a682e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a682e",
  null
  
)

export default component.exports